import { createApp } from "vue";
import Antd from "ant-design-vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import { DO_LOGOUT } from "@/store/modules/autenticacao/types";
import { install } from "vue3-recaptcha-v2";
import VueTheMask from "vue-the-mask";

import "@/assets/styles/theme.less";

const app = createApp(App);

app.config.globalProperties.$logout = () => {
	store.dispatch(DO_LOGOUT);

	router.push({ name: "login" });

	return;
};

app.use(install, {
	sitekey: process.env.VUE_APP_KEY_RECAPTCHA_V2,
	cnDomains: false,
})
	.use(Antd)
	.use(store)
	.use(router)
	.use(VueTheMask)
	.mount("#app");
